<template>
    <div class="menu" :class="{open}" v-click-outside="clickOutside">
        <div class="head">
            <div class="close-btn" @click="close">
                <CloseIcon :size="32"/>
            </div>
        </div>
        <div class="scrollable">
            <div class="extras">
                <LanguagePicker class="language-picker"/>
            </div>
            <div class="items" @click="routeClick">
                <template v-for="(item, id) in items.main" :key="`menu-item-${id}`" >
                    <MenuItem :data="item" :id="id" v-if="canBeSeen(item) === 'true'"/>
                </template>
                <template v-if="isTeamleader">
                    <template v-for="(item, id) in items.leader" :key="`menu-item-${id}`" >
                        <MenuItem :data="item" :id="id" v-if="canBeSeen(item) === 'true'" />
                    </template>
                </template>


                <div v-if="isAdmin">
                    <template v-for="(item, id) in items.admin" :key="`menu-item-${id}`" >
                        <MenuItem :data="item" :id="id" v-if="canBeSeen(item) === 'true'" />
                    </template>
                </div>

                <template v-for="(item, id) in items.afterLeader" :key="`menu-item-${id}`" >
                    <MenuItem :data="item" :id="id" v-if="canBeSeen(item) === 'true'" />
                </template>
            </div>

            <div class="menu-footer" v-if="dealer" @click="gotoMypage">
                <div class="footer-head">
                    <div class="details">
                        <div class="name">{{fullName}}</div>
                        <div class="dealer-number">{{$t('common.dealerNr', [dealerNumber])}}</div>
                    </div>
                    <div class="avatar" :style="CSS_avatarBackground" :alt="fullName"></div>
                </div>
                <div class="footer-menu" v-if="footerEnabled">
                    <template v-for="(item, id) in items.footer" :key="`menu-item-${id}`" >
                        <router-link class="footer-menu-item" v-if="canBeSeen(item) === 'true'" :to="item.route">{{ $t(item.label) }}</router-link>
                    </template>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
 import * as types from '@/store/mutations.js'
 import CloseIcon from '@/components/core/CloseColorable.vue'
 import MenuItem from '@/components/core/MenuItem.vue'
 import LanguagePicker from '@/components/core/LanguagePicker.vue'
 import { mapGetters} from 'vuex'
 import vClickOutside from 'click-outside-vue3'

 export default {
     name: "HeaderMenu",
     components: {
         CloseIcon,
         MenuItem,
         LanguagePicker
     },
     directives: {
         clickOutside: vClickOutside.directive
     },
     methods: {
         close(){
             this.$store.commit(types.CLOSE_MENU)
         },
         routeClicked(){
             this.close()
             window.scrollTo(0,0)
         },
         canBeSeen(item){
             if(item.devOnly){
                 return this.isDevEnv
             }else{
                 return 'true'
             }
         },
         clickOutside(){
             if(this.open){
                 let now = new Date().getTime()
                 if(now > this.clickOutsideIgnoredUntil){
                     this.close()
                 }
             }
         },
         gotoMypage(){
             this.$router.push("/Me");

         }
     },
     computed: {
         ...mapGetters(['user','dealer','isDevEnv']),
         open(){
             return this.$store.state.system.menuOpen
         },
         fullName(){
             return this.user.firstName + ' ' + this.user.lastName
         },
         dealerNumber(){
             return this.dealer?.id ?? -1
         },
         isTeamleader(){
             return this.dealer?.isTeamleader ?? false
         },
         isAdmin(){
             return this.dealer?.isAdmin ?? false
         },
         footerEnabled(){
             return false
         },

         CSS_avatarBackground(){
             let bg = 'none'
             let dealer = this.dealer
             let file = dealer?.profile?.fileName
             let folder = 'https://admin.perfecthome.no/images/profileImages'

             if(file){
                 bg = `url(${folder}/${file})`
             }

             return { 'background-image': bg }
         },

         items(){
             let notifications = this.$store.getters.unreadNotifications
             return {
                 main: {
                     front: { route: { name: 'FrontPage'}, label: 'main.frontpage' },
                     //dashboard: { route: { name: 'DashBoard'}, label: 'main.dashboard' },
                     newsfeed: { route: { name: 'NewsFeed' }, label: 'main.newsfeed', notifications: notifications.inbox },
                     products: { route: { name: 'ProductList' }, label: 'main.products' },
                     calendar: { route: { name: 'CalendarPage' }, label: 'main.calendar' },
                     crm: { route: { name: 'Crm' }, label: 'main.crm' },
                     orders: {
                         label: 'main.orders',
                         children: {
                             order: { route: { name: 'Order' }, label: 'main.order' },
                             orderHistory: { route: { name: 'OrderHistory' }, label: 'main.orderHistory' },
                             invoiceHistory: { route: { name: 'InvoiceHistory' }, label: 'main.invoiceHistory' },
                             returnsOverview: { route: { name: 'ReturnsOverview' }, label: 'main.returnsOverview' },
                             backorders: { route: { name: 'Backorders' }, label: 'main.backorders' },
                         }
                     },
                     results:{
                         label: 'main.results',
                         children: {
                             myresults: {
                                 route: {
                                     name: 'MyResults'
                                 },
                                 label: 'main.myresults'
                             },
                             leaderboards: {
                                 route: {
                                     name: 'Leaderboards'
                                 },
                                 label: 'main.leaderboards'
                             },
                             kickback: {
                                route: {
                                    name: 'KickbackMain',
                                },
                                label: 'main.kickback'
                             },
                         }
                     },
                     /*
                     campaigns:{
                         label: 'main.campaigns',
                         children: {
                             campaigns: {
                                 route: {
                                     name: 'Campaigns'
                                 },
                                 label: 'main.campaigns'
                             },
                             demoCampaigns: {
                                 route: {
                                     name: 'DemoCampaigns'
                                 },
                                 label: 'main.demoCampaigns' },
                         }
                     },
                     */

                 },
                 leader: {
                     leader: {
                         label: 'main.team.menu',
                         children: {
                             teamSales:    { route: { name: 'TeamSales' },    label: 'main.team.sales' },
                             teamInsight:  { route: { name: 'TeamInsight', params: {artno:'NA',week:99} },  label: 'main.team.insight' },
                             teamRecruits: { route: { name: 'TeamRecruits' }, label: 'main.team.recruits' },
                             teamKickback: { route: { name: 'TeamKickback' }, label: 'main.team.kickback' },
                             teamDRM:      { route: { name: 'DRM' },          label: 'main.team.drm', devOnly: true },
                             teamSettings: { route: { name: 'TeamSettings' }, label: 'main.team.settings' }
                         }
                     }
                 },

                 admin: {
                     admin: {
                         label: 'main.admin.menu',
                         children: {
                             admin: { route: { name: 'AdminMain' }, label: 'main.admin.admin' },
                             adminDealers: { route: { name: 'DRM' }, label: 'main.admin.dealers' },
                             adminProfiles: { route: { name: 'ProfileAdmin' }, label: 'main.admin.profileManagement' },
                             adminReturns: { route: { name: 'AdminClaims' }, label: 'main.admin.adminReturns' }
                         }
                     }
                 },
                 afterLeader: {
                     logout: { route: { name: 'LogOut' }, label: 'main.logout' }
                 },
                 footer: {
                     mysite: { route: { name: 'DashBoard' }, label: 'main.mysite' },
                     orderDemoProducts: { route: { name: 'DashBoard' }, label: 'main.orderDemoProducts' },
                     other: { route: { name: 'DashBoard' }, label: 'main.other' }
                 }
             }
         }
     },
     watch: {
         open: {
             handler(){
                 this.clickOutsideIgnoredUntil = new Date().getTime()+100
             },
             immediate: true
         }
     },
     data(){
         return {
             clickOutsideConfig: {
                 handler: this.clickOutside,
                 capture: false
             },
             clickOutsideIgnoredUntil: new Date().getTime()+100,
         }
     }
 }

 /*
    resultgroup: {
    label: "main.results",
    childern: {
    results:{
    route: {
    name: 'MyResults'
    },
    label: 'main.myresults'
    },
    leaderboards:{
    route: {
    name: 'Leaderboards'
    },
    label: 'main.leaderboards'
    },
    },
    },

  */

</script>

<style scoped>
.menu {
    text-align: left;
    width: 100vw;
    max-width: 100vw;
    z-index: 11;
    background-color: #fff;
    position: fixed;
    top: 0;
    bottom: 0;
    box-shadow: 0px 3px 6px rgba(0,0,0,0.16);
    transform: translateX(-105%);
    transition: all .2s ease-in-out;
}
.menu.open {
   transform: translateX(0);
}

.scrollable {
    height: 100%;
    overflow-y: auto;
    padding-bottom: 40px;
}

.extras {
    margin-top: 24px;
    margin-right: 24px;
    margin-bottom: 24px;
    margin-left: 30px;
}
.language-picker {
    margin-left: auto;
    z-index: 2;
}
.head {
    position: absolute;
    left: 0;
    top: 0;
    height: 60px;
    right: 0;
    background-color: rgba(255,255,255,0.48);
    backdrop-filter: saturate(1.8) blur(16px);
}
.close-btn {
    color: #E77423;
    position: absolute;
    top: 0;
    left: 0;
    display: flex;
    width: 60px;
    height: 60px;
    align-items: center;
    justify-content: center;
    transition: 0.2s all ease;
    cursor: pointer;
}
.close-btn svg {
    display: block;
}
 .close-btn:hover {
    background-color: rgba(0,0,0,0.05);
}


.extras {
    display: flex;
}

.menu-footer{
    cursor: pointer;
}


@media (min-width: 768px) {
    .menu {
        z-index: 9;
        left: 0;
        transform: translateX(-105%);
        width: 100%;
        max-width: 414px;
        padding-top: 60px;
    }
    .head {
        display: none;
    }

    .menu .extras {
        margin-bottom: -36px
    }

}

.menu-footer {
    margin-top: 22px;
    border-top: 1px solid #D7DDDD;
    padding-top: 22px;
}

.avatar {
    display: block;
    width: 48px;
    height: 48px;
    border: 2px solid white;
    box-shadow: 0px 3px 6px rgba(0,0,0,0.16);
    border-radius: 50%;
    background-color: #D7DDDD;
    background-position: center;
    background-size: cover;
}

.footer-menu-item {
    color: #2C3536;
    font-size: 14px;
    line-height: 21px;
    font-weight: normal;
    padding-top: 8px;
    padding-bottom: 8px;
}

.footer-head {
    padding-left: 32px;
    padding-right: 24px;
    display: flex;
    margin-bottom: 12px;
}
.footer-head .details {
    flex: 1;
    padding-top: 7px;
}

.footer-menu {
    display: flex;
    flex-flow: column;
    padding-left: 32px;
}

.dealer-number {
    color: #687374;
    font-size: 12px;
    font-weight: normal;
}

</style>
